export enum LocalStorageEnum {
  ACCESS_TOKEN = "AEA-painel-access_token",
}
